import { atom } from "jotai";

export type TonClientType = typeof import("@/api/client");

export const tonClientAtom = atom<TonClientType | undefined>(undefined);
